export enum InterventionNotAvailableReason {
  INTERVENTION_DRAFT = 'INTERVENTION_DRAFT',
  INTERVENTION_CLOSED = 'INTERVENTION_CLOSED',
  INTERVENTION_PAUSED = 'INTERVENTION_PAUSED',
  SESSION_CLOSED = 'SESSION_CLOSED',
  RA_SESSION_PENDING = 'RA_SESSION_PENDING',
}
